import React from 'react';

// Real SNCF Voyageurs logo (provided by user)
export const SncfVoyageursLogo = ({ className = '', height = 36 }) => (
  <img
    src="/assets/sncf_voyageurs.png"
    alt="SNCF Voyageurs"
    style={{ height }}
    className={`object-contain ${className}`}
  />
);

// Real FLUO Grand Est logo (provided by user, converted from PDF)
export const FluoLogo = ({ className = '', height = 28 }) => (
  <img
    src="/assets/fluo_grand_est.png"
    alt="Fluo Grand Est"
    style={{ height }}
    className={`object-contain ${className}`}
  />
);

export default SncfVoyageursLogo;
